<!-- 加入我们 -->
<template>
  <div class="pageView">
    <PCNavbar></PCNavbar>
    <CarouselHome type="joinUs"></CarouselHome>
    <div class="main-wrap">
      <div class="block-wrap">
        <div class="tab">
          <div class="tab-item" :class="{ current: current == 1 }" @click="toggle(1)">人员招聘</div>
          <div class="tab-item" :class="{ current: current == 2 }" @click="toggle(2)">志愿者招聘</div>
          <div class="tab-item" :class="{ current: current == 3 }" @click="toggle(3)">联系我们</div>
        </div>
        <div class="article" v-show="current == 1 && step == 0">
          <h3 class="h3">职位类别</h3>
          <div class="mobile-select">
            <el-select v-model="selectBumen" placeholder="请选择职位类别" multiple collapse-tags size="small" @change="selectBumenChangeHandle">
              <el-option v-for="item in bumenList" :key="item.id" :label="item.title" :value="item.id" />
            </el-select>
          </div>
          <div class="main">
            <div class="left">
              <el-checkbox-group v-model="selectBumen" @change="selectBumenChange">
                <el-checkbox v-for="item in bumenList" :key="item.id" :label="item.id">{{ item.title }}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="right">
              <div class="list">
                <el-card v-for="item in filterwangweiList" :key="item.id" shadow="never" class="card-item">
                  <div class="card">
                    <div class="title">{{ item.title }}</div>
                    <div class="info">
                      <span class="msg">{{ item.city }}</span>
                      <span class="divider"></span>
                      <span class="msg">{{ item.createtime_text }}</span>
                      <span class="divider"></span>
                      <span class="msg">{{ item.type == 1 ? "全职" : "兼职" }}</span>
                      <span class="divider"></span>
                      <span class="msg">{{ item.number }}</span>
                    </div>
                    <div class="content">
                      <div class="gwmc">岗位职责</div>
                      <div class="gwnr" v-html="item.duty"></div>
                      <div class="gwmc">岗位要求</div>
                      <div class="gwnr">{{ item.require }}</div>
                    </div>
                    <div class="btn-group">
                      <el-button class="btn" @click="getGangweiDetail(item)">查看详情</el-button>
                    </div>
                  </div>
                </el-card>
              </div>
            </div>
          </div>
        </div>
        <div class="article" v-show="current == 1 && step == 1">
          <div class="title-box">
            <h3 class="h3">职位详情</h3>
            <el-link :underline="false" class="text-btn" @click="step = 0">返回类别</el-link>
          </div>
          <div class="list">
            <el-card shadow="never" class="card-item">
              <div class="card">
                <div class="title">{{ detail.title }}</div>
                <div class="info">
                  <span class="msg">{{ detail.city }}</span>
                  <span class="divider"></span>
                  <span class="msg">{{ detail.createtime_text }}</span>
                  <span class="divider"></span>
                  <span class="msg">{{ detail.type == 1 ? "全职" : "兼职" }}</span>
                  <span class="divider"></span>
                  <span class="msg">{{ detail.number }}</span>
                </div>
                <div class="content">
                  <div class="gwmc">岗位职责</div>
                  <div class="gwnr">{{ detail.duty }}</div>
                  <div class="gwmc">岗位要求</div>
                  <div class="gwnr">{{ detail.require }}</div>
                </div>
                <div class="btn-group">
                  <el-button class="btn" v-if="detail.is_apply == 0" @click="applygw">申请岗位</el-button>
                  <el-button class="btn is-disabled" v-if="detail.is_apply == 1" :disabled="true">已投递</el-button>
                </div>
              </div>
            </el-card>
          </div>
        </div>
        <div class="article" v-show="(current == 1 && step == 2) || (current == 2 && step == 1)">
          <h3 class="h3" v-if="current == 1 && step == 2">人员招聘申请</h3>
          <h3 class="h3" v-if="current == 2 && step == 1">志愿者申请</h3>
          <el-form class="form" ref="formRef" :model="form" :rules="formRules" label-position="top">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="性别" prop="sex">
              <el-checkbox-group v-model="form.sex" @change="handleChangeSex">
                <el-checkbox :label="1" size="large">男</el-checkbox>
                <el-checkbox :label="2" size="large">女</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="出生年月" prop="birthday">
              <el-date-picker v-model="form.birthday" type="date" style="width: 100%" placeholder="请选择日期" />
            </el-form-item>
            <el-form-item label="1寸免冠照片" prop="photo">
              <div class="flex-start-end">
                <div class="pictrue flex-center">
                  <img v-if="form.photo.length > 0" :src="form.photo" />
                  <img v-else src="@/assets/images/pictrue.png" />
                </div>
                <el-upload
                  v-model="fileListPhoto"
                  class="upload-demo"
                  :action="uploadUrl"
                  :show-file-list="false"
                  :headers="{ token: userInfo?.token }"
                  :before-upload="(file) => beforeUpload(file, 'photo')"
                  :on-remove="(file, list) => handleRemove(file, list, 'photo')"
                  :on-success="(res, file, list) => handleSuccess(res, file, list, 'photo')"
                >
                  <el-button class="btn" style="width: auto; height: auto" icon="el-icon-document-add">点击上传</el-button>
                  <template #tip>
                    <div class="el-upload-tip"><i class="el-icon-warning-outline" /> 建议图片格式为.jpg/.png/.jpeg，图片大小不超过30M</div>
                    <div class="el-upload-tip"><i class="el-icon-warning-outline" /> 选择文件（1个）</div>
                  </template>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="民族" prop="nation">
              <el-input v-model="form.nation" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="政治面貌" prop="political_status">
              <el-checkbox-group v-model="form.political_status" @change="handleChangeMm">
                <el-checkbox :label="1">群众</el-checkbox>
                <el-checkbox :label="2">共青团员</el-checkbox>
                <el-checkbox :label="3">中共党员</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobile">
              <el-input v-model="form.mobile" maxlength="11" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="form.email" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="通讯地址" prop="address">
              <el-input v-model="form.address" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="身份证号码" prop="idcard">
              <el-input v-model="form.idcard" maxlength="18" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="学历" prop="education">
              <el-input v-model="form.education" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="学校/工作单位" prop="unit">
              <el-input v-model="form.unit" placeholder="请输入" />
            </el-form-item>
            <template v-if="current == 2 && step == 1">
              <el-form-item label="志愿服务意向" prop="jobs_id">
                <el-checkbox-group v-model="form.jobs_id" @change="handleJobsIdChange">
                  <el-checkbox v-for="item in checkList" :key="item.id" :label="item.id">{{ item.title }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="可提供志愿服务时间" prop="time_type">
                <el-checkbox-group v-model="form.time_type" @change="handleTimeTypeChange">
                  <el-checkbox :label="1">15天以上</el-checkbox>
                  <el-checkbox :label="2">10天以上</el-checkbox>
                  <el-checkbox :label="3">按小时算</el-checkbox>
                  <el-checkbox :label="4">其他</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item prop="time_text" v-if="form.time_type[0] == 4">
                <el-input v-model="form.time_text" placeholder="请输入" />
              </el-form-item>
            </template>
            <el-form-item label="荣誉及获奖情况" prop="honor">
              <el-input v-model="form.honor" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="特长" prop="talent">
              <el-input v-model="form.talent" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="健康状况证明" prop="health">
              <div class="flex-start-end">
                <div class="pictrue">
                  <img v-if="form.health.length > 0" :src="form.health" />
                </div>
                <el-upload
                  v-model="fileListHealth"
                  class="upload-demo"
                  :action="uploadUrl"
                  :show-file-list="false"
                  :headers="{ token: userInfo?.token }"
                  :before-upload="(file) => beforeUpload(file, 'health')"
                  :on-remove="(file, list) => handleRemove(file, list, 'health')"
                  :on-success="(res, file, list) => handleSuccess(res, file, list, 'health')"
                >
                  <el-button class="btn" style="width: auto; height: auto" icon="el-icon-document-add">点击上传</el-button>
                  <template #tip>
                    <div class="el-upload-tip"><i class="el-icon-warning-outline" /> 选择文件（1个），每个30M以内</div>
                  </template>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="入职宣言" prop="entry">
              <el-input v-model="form.entry" type="textarea" :autosize="{ minRows: 6, maxRows: 30 }" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="附件" prop="fileList">
              <div class="flex-start-end">
                <div class="pictrue"></div>
                <el-upload
                  v-model="fileListFile"
                  class="upload-demo"
                  :action="uploadUrl"
                  multiple
                  :show-file-list="false"
                  :headers="{ token: userInfo?.token }"
                  :before-upload="(file) => beforeUpload(file, ' ')"
                  :on-remove="(file, list) => handleRemove(file, list, 'fileListFile')"
                  :on-success="(res, file, list) => handleSuccess(res, file, list, 'fileListFile')"
                >
                  <el-button class="btn" style="width: auto; height: auto" icon="el-icon-document-add">点击上传</el-button>
                  <template #tip>
                    <div class="el-upload-tip"><i class="el-icon-warning-outline" /> 每个30M以内</div>
                  </template>
                </el-upload>
              </div>
              <div v-if="fileListArr.length > 0" style="display: flex;margin-top: 20px;" class="pictrue">
                <img v-for="(item, index) in fileListArr" :key="index" :src="item"/>
              </div>
            </el-form-item>
          </el-form>
          <div class="btn-group ptb flex-center">
            <el-button type="primary" class="btn w48" @click="submitVlidate">提交</el-button>
          </div>
        </div>
        <div class="article" v-show="current == 2 && step == 0">
          <h3 class="h3">志愿者介绍</h3>
          <div class="desc">{{ config?.zyzjs }}</div>
          <h3 class="h3">志愿者岗位</h3>
          <div class="list" :style="{ paddingTop: platform == 'web' ? '50px' : '20px', display: 'block' }">
            <el-row :gutter="platform == 'web' ? 40 : 20">
              <el-col :span="24" v-for="(item, index) in checkList" :key="index">
                <el-card shadow="never" class="card-item">
                  <div class="card">
                    <div class="title">{{ item.title }}</div>
                    <div class="content">
                      <div class="gwmc">岗位职责</div>
                      <div class="gwnr" v-html="item.duty"></div>
                      <div class="gwmc">报名要求</div>
                      <div class="gwnr" v-html="item.require"></div>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <div class="btn-group ptb flex-center">
              <el-button class="btn w48" @click="applyBm">报名通道</el-button>
            </div>
          </div>
        </div>
        <div class="article" v-show="current == 3">
          <h3 class="h3">联系我们</h3>
          <div class="box">
            <div class="row">
              <span class="label">工作时间：</span><span class="value">{{ config.gzsj }}</span>
            </div>
            <div class="row">
              <span class="label">战略合作：</span><span class="value">{{ config?.zlhz }}</span>
            </div>
            <div class="row">
              <span class="label">公益热线：</span><span class="value">{{ config.gyrx }}</span>
            </div>
            <div class="row">
              <span class="label">联系方式：</span><span class="value">{{ config.tel }}</span>
            </div>
            <div class="row">
              <span class="label">官方邮箱：</span><span class="value">{{ config.email }}</span>
            </div>
            <div class="row">
              <span class="label">办公地址：</span><span class="value">{{ config.address }}</span>
            </div>
            <div class="row">
              <span class="label">邮 编：</span><span class="value">{{ config?.youbian }}</span>
            </div>
          </div>
          <h3 class="h3">关注我们</h3>
          <div class="box2">
            <div class="top">
              <img class="ewm" v-for="item in list" :key="item.id" :src="item.images.split(',')[0]" />
              <img class="ewm" style="opacity: 0;" src="https://cifugw.cifujijin.com/uploads/20250730/fc8d87334b3fdf453f660e2cc229895a.png" v-if="list.length % 2 == 1" />
            </div>
            <div class="bot">
              <img class="icon" v-for="item in list" :key="item.id" :src="item.icon" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <el-dialog :visible.sync="dialogVisible" width="324px" center append-to-body top="30vh" :show-close="false" :custom-class="'custom-dialog'">
      <div class="dialog">
        <div class="dialog-popup">
          <img src="@/assets/images/success.png" />
          <div class="dialog-title">岗位申请成功</div>
          <div class="dialog-content">岗位投递成功，请耐心等待</div>
        </div>
        <i class="el-icon-circle-close" @click="dialogVisible = false" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { baseURL } from "@/utils/http";
import { mapState } from "vuex";
import PCNavbar from "@/components/navbar/index";
import CarouselHome from "@/components/carousel_home/index";
import Footer from "@/components/footer/index";

export default {
  name: "JoinUs",
  components: { PCNavbar, CarouselHome, Footer },
  data() {
    return {
      current: 1,
      step: 0,
      detail: {},
      list: [],
      selectBumen: [],
      bumenList: [],
      gangweiList: [],
      checkList: [],
      form: {
        name: "",
        jobs_id: "",
        sex: [],
        birthday: "",
        photo: "",
        nation: "",
        political_status: [],
        mobile: "",
        email: "",
        address: "",
        idcard: "",
        education: "",
        unit: "",
        honor: "",
        talent: "",
        health: "",
        attachment: "",
        entry: "",
        time_type: [],
        time_text: ""
      },
      formRules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 10, message: "姓名长度在2到10个字符之间", trigger: "blur" },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        birthday: [{ required: true, message: "请选择出生年月", trigger: "blur" }],
        photo: [{ required: true, message: "请上传1寸免冠照片", trigger: "blur" }],
        nation: [{ required: true, message: "请输入民族", trigger: "blur" }],
        political_status: [{ required: true, message: "请输入政治面貌", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "手机号格式不正确", trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确", trigger: "blur" },
        ],
        address: [{ required: true, message: "请输入通讯地址", trigger: "blur" }],
        idcard: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: "身份证号码格式不正确", trigger: "blur" },
        ],
        education: [{ required: true, message: "请输入学历", trigger: "blur" }],
        unit: [{ required: true, message: "请输入学校/工作单位", trigger: "blur" }],
        jobs_id: [{ required: true, message: "请选择志愿服务意向", trigger: "change" }],
        time_type: [{ required: true, message: "请选择可提供志愿服务时间", trigger: "change" }],
        time_text: [{ required: true, message: "请输入志愿服务时间", trigger: "blur" }],
        entry: [{ required: true, message: "请输入入职宣言", trigger: "blur" }],
      },
      fileListPhoto: [],
      fileListHealth: [],
      fileListArr: [],
      fileListFile: [],
      uploadUrl: `${baseURL}/api/common/upload`,
      dialogVisible: false,
    };
  },
  computed: {
    ...mapState(["config", "platform", "userInfo"]),
    filterwangweiList() {
      return this.gangweiList.filter((item) => this.selectBumen.includes(item.cate_id));
    },
  },
  watch: {
    step(newVal) {
      if (newVal === 0) {
        this.resetForm();
      }
    },
    detail: {
      handler(newVal) {
        this.detail = newVal;
      },
      deep: true,
    },
  },
  created() {
    this.$watch(
      "$route",
      (to) => {
        const index = to.params.id || 1;
        this.toggle(index);
      },
      { immediate: true }
    );
    this.getList();
  },
  methods: {
    toggle(index) {
      this.current = index;
      this.step = 0;
      if (index == 1) {
        this.getBumenList();
        this.getGangweiList();
      } else if (index == 2) {
        this.getList2();
      } else {
        this.getList();
      }
      this.$store.dispatch("setMenuActive", "/joinUs?type=" + index);
      // 更新路由参数
      this.$router
        .push({
          path: `/joinUs/${index}`,
        })
        .catch((err) => {
          // 忽略重复导航的错误
          if (err.name !== "NavigationDuplicated") {
            // 如果不是重复导航的错误，重新抛出
            throw err;
          }
        });
    },

    selectBumenChange(e) {
      // 单选模式
      // const lastSelected = e[e.length - 1];
      // this.selectBumen = [lastSelected];
      // this.getGangweiList();
      // 多选模式
      this.selectBumen = e;
    },
    selectBumenChangeHandle(e) {
      this.selectBumen = e;
      this.getGangweiList();
    },
    async getDetail() {
      const res = await CifuAPI.getArticleDetail({ unicode: "dangzhibujieshao" });
      this.detail = res.data;
    },
    async getList() {
      const res = await CifuAPI.getBottomIcons();
      this.list = res.data;
    },

    async getBumenList() {
      const res = await CifuAPI.getDeptList();
      this.bumenList = res.data;
      this.selectBumen = res.data.map((item) => item.id);
    },
    async getGangweiList() {
      const res = await CifuAPI.getJobList({ job_type: 1 });
      this.gangweiList = res.data;
    },
    async getList2() {
      const res = await CifuAPI.getJobList({ job_type: 2 });
      this.checkList = res.data;
    },
    // 岗位详情
    async getGangweiDetail(item) {
      this.step = 1;
      const res = await CifuAPI.getJobDetail({ id: item.id });
      this.detail = res.data;
    },
    // 申请岗位
    applygw() {
      this.step = 2;
      this.form.jobs_id = this.detail.id;
    },

    applyBm() {
      this.step = 1;
    },

    handleChangeSex(val) {
      const lastSelected = val[val.length - 1];
      this.form.sex = [lastSelected];
    },
    handleChangeMm(val) {
      const lastSelected = val[val.length - 1];
      this.form.political_status = [lastSelected];
    },

    handleJobsIdChange(val) {
      const lastSelected = val[val.length - 1];
      this.form.jobs_id = [lastSelected];
    },

    handleTimeTypeChange(val) {
      const lastSelected = val[val.length - 1];
      this.form.time_type = [lastSelected];
    },

    // 上传前验证
    beforeUpload(file, type) {
      if (type == 'photo') {
        this.fileListPhoto = []
      }
      if (type == 'health') {
        this.fileListHealth = []
      }
      if (type == 'fileListFile') {
        this.fileListFile = []
      }
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      const isValidType = validTypes.includes(file.type);
      const isValidSize = file.size / 1024 / 1024 < 30;

      if (!isValidType) {
        this.$message.error("只能上传 JPG/JPEG/PNG 格式的图片!");
        return false;
      }

      if (!isValidSize) {
        this.$message.error("图片大小不能超过 30MB!");
        return false;
      }

      return true;
    },

    // 通用删除处理
    handleRemove(file, fileList, type) {
      if (type == 'photo') {
        this.fileListPhoto = fileList
      }
      if (type == 'health') {
        this.fileListHealth = fileList
      }
      if (type == 'fileListFile') {
        this.fileListFile = fileList
      }
      if (type === "photo") {
        this.form.photo = ""; // 清空照片路径
      } else if (type === "health") {
        this.form.health = ""; // 清空健康证明路径
      } else {
        console.log(this.fileListFile)
      }
    },

    // 通用上传成功处理
    handleSuccess(res, file, fileList, type) {
      if (type == 'photo') {
        this.fileListPhoto = []
        this.fileListPhoto = fileList
      }
      if (type == 'health') {
        this.fileListHealth = []
        this.fileListHealth = fileList
      }
      if (type == 'fileListFile') {
        this.fileListFile = []
        this.fileListFile = fileList
      }
      if (res.code == 1) {
        if (type === "photo") {
          this.form.photo = res.data.fullurl; // 赋值照片路径
        } else if (type === "health") {
          this.form.health = res.data.fullurl; // 赋值健康证明路径
        } else {
          this.fileListArr.push(res.data.fullurl)
          this.form.attachment = this.fileListArr.join(',')
        }
      } else {
        this.$message.error("上传失败，请重试");
      }
    },
    submitVlidate() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          this.submit();
        }
        return false;
      });
    },
    async submit() {
      const data = JSON.parse(JSON.stringify(this.form));
      data.sex = data.sex.toString();
      data.political_status = data.political_status.toString();
      if (this.current == 2 && this.step == 1) {
        data.jobs_id = data.jobs_id.toString();
        data.time_type = data.time_type.toString();
      } else {
        delete data.time_type;
        delete data.time_text;
      }
      const res = await CifuAPI.apply(data);
      if (res.code == 1) {
        this.dialogVisible = true;
        this.resetForm();
        // this.getGangweiDetail({ id: this.detail.id });
      } else {
        this.$message.error("提交失败");
      }
    },
    // 提交成功后调用此方法重置表单
    resetForm() {
      // 重置表单字段
      this.form = {
        name: "",
        jobs_id: "",
        sex: [],
        birthday: "",
        photo: "",
        nation: "",
        political_status: [],
        mobile: "",
        email: "",
        address: "",
        idcard: "",
        education: "",
        unit: "",
        honor: "",
        talent: "",
        health: "",
        entry: "",
        time_type: [],
        time_text: "",
      };

      // 重置上传组件的文件列表
      this.fileListPhoto = [];
      this.fileListHealth = [];
      this.$refs.formRef.resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.pageView{
  width: 100%;
  min-width: 1400px;
}
.article {
  .h3 {
    padding-top: 10px;
    font-size: 28px;
    color: #663301;
    // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    //   padding-top: 0;
    //   font-size: 16px;
    // }
  }
  .desc {
    padding-top: 50px;
    font-size: 18px;
    color: #828282;
    line-height: 32px;
    // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    //   padding-top: 20px;
    //   font-size: 14px;
    //   line-height: 24px;
    // }
  }
  .box {
    display: flex;
    flex-wrap: wrap;
    width: 700px;
    padding: 50px 0 0;
    // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    //   width: 100%;
    //   padding: 20px 0 0;
    // }
    .row {
      flex: 0 0 250px;
      min-width: 250px;
      margin-right: 100px;
      margin-bottom: 12px;
      line-height: 32px;
      font-size: 18px;
      color: #4f4f4f;
      white-space: nowrap;
      // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      //   flex: 0 0 100%;
      //   min-width: 100%;
      //   margin-right: 0;
      //   font-size: 14px;
      // }
      .value {
        vertical-align: top;
        // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        //   width: calc(100% - 90px);
        //   white-space: normal;
        // }
      }
    }
    .label {
      display: inline-block;
      width: 90px;
      text-align: justify;
      text-align-last: justify;
      vertical-align: top;
    }
  }
  .top {
    padding-top: 40px;
    display: flex;
    gap: 44px;
    // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    //   padding-top: 20px;
    //   flex-wrap: wrap;
    //   gap: 10px;
    // }
    .ewm {
      width: 180px;
      height: 180px;
      background: #d9d9d9;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        flex: 1;
        width: calc(50% - 5px);
        height: 163px;
      }
    }
  }
  .bot {
    padding-top: 40px;
    display: flex;
    gap: 33px;
    .icon {
      width: 41px;
      height: 41px;
      border-radius: 50%;
    }
  }
  .title-box {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 20px;
    .h3 {
      border-bottom: none;
    }
    .text-btn {
      padding-bottom: 30px;
      font-size: 16px;
      color: #828282;
    }
  }
  .card {
    padding: 12px 20px;
    // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    //   padding: 0;
    // }
    &-item {
      width: 100%;
      margin-bottom: 30px;
      border: none;
      background-color: #fffbeb;
      // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      //   width: 100%;
      // }
    }
    .title {
      font-weight: bold;
      font-size: 28px;
      color: #663301;
      // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      //   font-size: 16px;
      // }
    }
    .content {
      padding: 30px 0 18px;
      // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      //   padding: 10px 0 10px;
      // }
      .gwmc {
        padding-bottom: 14px;
        font-weight: bold;
        font-size: 18px;
        color: #663301;
        // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        //   font-size: 14px;
        //   padding-bottom: 10px;
        // }
      }
      .gwnr {
        line-height: 21px;
        margin-bottom: 10px;
        font-size: 18px;
        color: rgba(102, 51, 1, 0.8);
        // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        //   font-size: 12px;
        // }
      }
    }
    .info {
      display: flex;
      align-items: center;
      padding-top: 18px;
      // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      //   flex-wrap: wrap;
      //   padding-top: 10px;
      // }
      .divider {
        width: 2px;
        height: 18px;
        background: #663301;
        margin: 0 10px;
        // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        //   width: 1px;
        //   height: 10px;
        //   margin: 0;
        // }
      }
      .msg {
        padding: 0 10px;
        font-size: 18px;
        color: #663301;
        &:first-child {
          padding-left: 0;
        }
        // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        //   font-size: 12px;
        // }
      }
    }
  }
}
.main {
  display: flex;
  height: 100%;
  background: none;
  // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
  //   padding: 0;
  // }
  .left {
    width: 320px;
    padding-top: 40px;
    border-right: 1px solid #e0e0e0;
    // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    //   display: none;
    // }
  }
  .right {
    flex: 1;
    padding: 20px 0 0 30px;
    // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    //   width: 100%;
    //   padding-left: 0;
    // }
  }
}
.form {
  padding-top: 30px;
  ::v-deep .el-form-item__label {
    font-size: 18px;
    // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    //   font-size: 16px;
    // }
  }
}
.btn-group {
  &.ptb {
    padding-top: 80px;
    padding-bottom: 30px;
    // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    //   padding-top: 20px;
    // }
  }
  .btn {
    &.w48 {
      width: 480px;
      height: 60px;
      // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      //   width: 100%;
      //   height: 40px;
      // }
    }
  }
}
</style>
